import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=ba12cdba&scoped=true"
import script from "./mine.vue?vue&type=script&lang=js"
export * from "./mine.vue?vue&type=script&lang=js"
import style0 from "./mine.vue?vue&type=style&index=0&id=ba12cdba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba12cdba",
  null
  
)

export default component.exports